import { Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaSimulationFcpiFormBuilder extends PrFormAbstract {
  options: any = {};

  generate(entity: any, options) {
    this.options = options;
    return this.formBuilder.group(
      {
        investedAmount: [
          entity ? entity.investedAmount : null,
          Validators.required,
        ],
        taxExemptionRate: [
          entity ? entity.taxExemptionRate : null,
          Validators.required,
        ],
      },
      {},
    );
  }

  extract() {
    let dto: any = {
      investedAmount: this.emptyIsNull(this.form.value.investedAmount),
      taxExemptionRate: this.emptyIsNull(this.form.value.taxExemptionRate),
    };
    return dto;
  }
}
